// ВНИМАНИЕ, КОЛЛЕГА!
// Этот компонент - чистое зло в его первозданной форме.
// Если ты читаешь это, значит, тебе не повезло и на тебя упала задача.
// Согласно древнему кодексу разработчиков, тот, кто трогает этот файл,
// ОБЯЗАН его полностью отрефакторить.
// Не будешь же ты лохом, правда? Удачи.
import { useRef, useState, useEffect } from 'react';
import { Modal, Button, Space, Slider, Input, ColorPicker, Select, Upload, Tabs, message, Spin, Row, Col, Card, Divider } from 'antd';
import {
    CheckOutlined, CloseOutlined, RotateLeftOutlined, RotateRightOutlined,
    FontSizeOutlined, BgColorsOutlined, PictureOutlined, UndoOutlined,
    RedoOutlined, DeleteOutlined, BoldOutlined, ItalicOutlined,
    UnderlineOutlined, ScissorOutlined, FilterOutlined,
    InstagramOutlined, FacebookOutlined, TwitterOutlined,
    LinkedinOutlined
} from '@ant-design/icons';
import { useTranslation, Trans } from 'react-i18next';
import ReactCrop from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';

const FILTER_PRESETS = {
    none: { nameKey: 'imageEditor.filters.none', brightness: 0, contrast: 0, saturation: 0, sepia: 0, grayscale: 0, blur: 0, hueRotate: 0 },
    clarendon: { nameKey: 'imageEditor.filters.clarendon', brightness: 10, contrast: 20, saturation: 15, sepia: 0, grayscale: 0, blur: 0, hueRotate: 0 },
    gingham: { nameKey: 'imageEditor.filters.gingham', brightness: 5, contrast: -10, saturation: -20, sepia: 0, grayscale: 0, blur: 0, hueRotate: 350 },
    moon: { nameKey: 'imageEditor.filters.moon', brightness: 10, contrast: 10, saturation: -100, sepia: 0, grayscale: 100, blur: 0, hueRotate: 0 },
    lark: { nameKey: 'imageEditor.filters.lark', brightness: 15, contrast: -10, saturation: 20, sepia: 0, grayscale: 0, blur: 0, hueRotate: 0 },
    reyes: { nameKey: 'imageEditor.filters.reyes', brightness: 10, contrast: -15, saturation: 30, sepia: 20, grayscale: 0, blur: 0, hueRotate: 0 },
    juno: { nameKey: 'imageEditor.filters.juno', brightness: 10, contrast: 15, saturation: 40, sepia: 0, grayscale: 0, blur: 0, hueRotate: 10 },
    slumber: { nameKey: 'imageEditor.filters.slumber', brightness: 5, contrast: -5, saturation: 20, sepia: 10, grayscale: 0, blur: 0, hueRotate: 0 },
    crema: { nameKey: 'imageEditor.filters.crema', brightness: 5, contrast: 10, saturation: -10, sepia: 15, grayscale: 0, blur: 0, hueRotate: 0 },
    ludwig: { nameKey: 'imageEditor.filters.ludwig', brightness: 10, contrast: 15, saturation: 10, sepia: 5, grayscale: 0, blur: 0, hueRotate: 0 },
    aden: { nameKey: 'imageEditor.filters.aden', brightness: 10, contrast: -10, saturation: -20, sepia: 0, grayscale: 0, blur: 0, hueRotate: 340 },
    amaro: { nameKey: 'imageEditor.filters.amaro', brightness: 10, contrast: 10, saturation: 30, sepia: 0, grayscale: 0, blur: 0, hueRotate: 0 },
    mayfair: { nameKey: 'imageEditor.filters.mayfair', brightness: 10, contrast: 10, saturation: 15, sepia: 5, grayscale: 0, blur: 0, hueRotate: 0 },
    rise: { nameKey: 'imageEditor.filters.rise', brightness: 15, contrast: 10, saturation: 20, sepia: 10, grayscale: 0, blur: 0, hueRotate: 0 },
    hudson: { nameKey: 'imageEditor.filters.hudson', brightness: 10, contrast: 10, saturation: 20, sepia: 0, grayscale: 0, blur: 0, hueRotate: 0 },
    valencia: { nameKey: 'imageEditor.filters.valencia', brightness: 10, contrast: 5, saturation: 10, sepia: 10, grayscale: 0, blur: 0, hueRotate: 5 },
    xpro2: { nameKey: 'imageEditor.filters.xpro2', brightness: 5, contrast: 25, saturation: 30, sepia: 10, grayscale: 0, blur: 0, hueRotate: 0 },
    sierra: { nameKey: 'imageEditor.filters.sierra', brightness: 10, contrast: 15, saturation: 20, sepia: 5, grayscale: 0, blur: 0, hueRotate: 0 },
    willow: { nameKey: 'imageEditor.filters.willow', brightness: 5, contrast: 5, saturation: -100, sepia: 0, grayscale: 50, blur: 0, hueRotate: 0 },
    lofi: { nameKey: 'imageEditor.filters.lofi', brightness: 5, contrast: 30, saturation: 20, sepia: 0, grayscale: 0, blur: 0, hueRotate: 0 },
    inkwell: { nameKey: 'imageEditor.filters.inkwell', brightness: 10, contrast: 10, saturation: -100, sepia: 0, grayscale: 100, blur: 0, hueRotate: 0 },
    nashville: { nameKey: 'imageEditor.filters.nashville', brightness: 10, contrast: 10, saturation: 20, sepia: 20, grayscale: 0, blur: 0, hueRotate: 10 },
};

const SOCIAL_PRESETS = {
    instagram: {
        nameKey: 'imageEditor.social.instagram.name',
        width: 1080,
        height: 1080,
        icon: <InstagramOutlined />,
        descriptionKey: 'imageEditor.social.instagram.description'
    },
    instagram_story: {
        nameKey: 'imageEditor.social.instagramStory.name',
        width: 1080,
        height: 1920,
        icon: <InstagramOutlined />,
        descriptionKey: 'imageEditor.social.instagramStory.description'
    },
    facebook: {
        nameKey: 'imageEditor.social.facebook.name',
        width: 1200,
        height: 630,
        icon: <FacebookOutlined />,
        descriptionKey: 'imageEditor.social.facebook.description'
    },
    threads: {
        nameKey: 'imageEditor.social.threads.name',
        width: 1080,
        height: 1350,
        icon: <TwitterOutlined />,
        descriptionKey: 'imageEditor.social.threads.description'
    },
    linkedin: {
        nameKey: 'imageEditor.social.linkedin.name',
        width: 1200,
        height: 627,
        icon: <LinkedinOutlined />,
        descriptionKey: 'imageEditor.social.linkedin.description'
    },
};

// Константы для кадрирования
const CROP_PRESETS = {
    free: { nameKey: 'imageEditor.crop.free', aspect: undefined },
    square: { nameKey: 'imageEditor.crop.square', aspect: 1 },
    instagram: { nameKey: 'imageEditor.crop.instagram', aspect: 4 / 5 },
    story: { nameKey: 'imageEditor.crop.story', aspect: 9 / 16 },
    landscape: { nameKey: 'imageEditor.crop.landscape', aspect: 16 / 9 },
    portrait: { nameKey: 'imageEditor.crop.portrait', aspect: 3 / 4 },
};

const ImageEditorModal = ({ visible, imageUrl, onSave, onCancel }) => {
    const { t } = useTranslation();

    const canvasRef = useRef(null);
    const previewCanvasRef = useRef(null);
    const containerRef = useRef(null);
    const imgRef = useRef(null);

    const [loading, setLoading] = useState(false);
    const [imageLoading, setImageLoading] = useState(true);
    const [activeTab, setActiveTab] = useState('social');

    const [originalImage, setOriginalImage] = useState(null);
    const [canvasSize, setCanvasSize] = useState({ width: 800, height: 600 });

    // Состояние для кадрирования
    const [cropMode, setCropMode] = useState(false);
    const [crop, setCrop] = useState({
        unit: '%',
        width: 90,
        height: 90,
        x: 5,
        y: 5
    });
    const [completedCrop, setCompletedCrop] = useState(null);
    const [cropAspect, setCropAspect] = useState(undefined);
    const [cropPreset, setCropPreset] = useState('free');

    const [brightness, setBrightness] = useState(0);
    const [contrast, setContrast] = useState(0);
    const [saturation, setSaturation] = useState(0);
    const [sepia, setSepia] = useState(0);
    const [grayscale, setGrayscale] = useState(0);
    const [blur, setBlur] = useState(0);
    const [hueRotate, setHueRotate] = useState(0);

    const [rotation, setRotation] = useState(0);
    const [selectedFilter, setSelectedFilter] = useState('none');

    const [textValue, setTextValue] = useState('');
    const [textColor, setTextColor] = useState('#ffffff');
    const [fontSize, setFontSize] = useState(40);
    const [fontFamily, setFontFamily] = useState('Arial');
    const [textBold, setTextBold] = useState(false);
    const [textItalic, setTextItalic] = useState(false);
    const [textUnderline, setTextUnderline] = useState(false);

    const [texts, setTexts] = useState([]);
    const [stickers, setStickers] = useState([]);
    const [selectedElement, setSelectedElement] = useState(null);
    const [isDragging, setIsDragging] = useState(false);
    const [dragOffset, setDragOffset] = useState({ x: 0, y: 0 });

    const [history, setHistory] = useState([]);
    const [historyStep, setHistoryStep] = useState(-1);

    // Функция для применения кадрирования - ПОЧИНЕННАЯ ВЕРСИЯ
    // Функция для применения кадрирования - ВОТ ТЕПЕРЬ ТОЧНО ПОЧИНЕННАЯ ВЕРСИЯ
    const applyCrop = () => {
        if (!completedCrop || !imgRef.current || !canvasRef.current || !originalImage) {
            message.warning(t('imageEditor.messages.noCropArea'));
            return;
        }

        const canvas = canvasRef.current;
        const ctx = canvas.getContext('2d');
        const image = imgRef.current;

        // СОХРАНЯЕМ ССЫЛКУ на старое изображение, чтобы избежать проблем с замыканием
        const oldImage = originalImage;

        // Эти вычисления абсолютно верны! Ты правильно нашел, как перевести
        // координаты с отображаемого изображения в координаты реального.
        const scaleX = image.naturalWidth / image.width;
        const scaleY = image.naturalHeight / image.height;

        const cropX = completedCrop.x * scaleX;
        const cropY = completedCrop.y * scaleY;
        const cropWidth = completedCrop.width * scaleX;
        const cropHeight = completedCrop.height * scaleY;

        // Проверяем, что область кадрирования не пустая
        if (cropWidth < 1 || cropHeight < 1) {
            message.error(t('imageEditor.messages.cropTooSmall'));
            return;
        }

        // Устанавливаем размер canvas под новое, кадрированное изображение
        canvas.width = cropWidth;
        canvas.height = cropHeight;

        // Рисуем кадрированную область на новом canvas
        ctx.drawImage(
            image,
            cropX, cropY, cropWidth, cropHeight, // source: что вырезаем из оригинала
            0, 0, cropWidth, cropHeight          // destination: куда вставляем на новом canvas
        );

        // Создаем новый объект Image из кадрированного canvas
        canvas.toBlob((blob) => {
            if (!blob) {
                message.error("Failed to create blob from canvas.");
                return;
            }
            const url = URL.createObjectURL(blob);
            const img = new Image();
            img.onload = () => {
                // Устанавливаем новое кадрированное изображение как основное
                setOriginalImage(img);

                // Теперь самое главное: правильно трансформируем координаты текста и стикеров

                // 1. Фильтруем тексты, которые остались внутри кадрированной области
                const updatedTexts = texts.filter(t => {
                    const textRight = t.x + (t.fontSize * (t.text.length * 0.6)); // Приблизительная ширина
                    const textBottom = t.y + t.fontSize;
                    return textRight > cropX && t.x < cropX + cropWidth && textBottom > cropY && t.y < cropY + cropHeight;
                })
                    // 2. Трансформируем их координаты в новую систему (относительно левого верхнего угла)
                    .map(t => ({
                        ...t,
                        x: t.x - cropX, // Просто вычитаем смещение!
                        y: t.y - cropY  // И здесь тоже!
                        // Размер шрифта НЕ меняем
                    }));

                setTexts(updatedTexts);

                // То же самое для стикеров
                const updatedStickers = stickers.filter(s => {
                    return s.x + s.width > cropX && s.x < cropX + cropWidth && s.y + s.height > cropY && s.y < cropY + cropHeight;
                })
                    .map(s => ({
                        ...s,
                        x: s.x - cropX,
                        y: s.y - cropY
                        // Размеры стикера НЕ меняем
                    }));

                setStickers(updatedStickers);

                // Выходим из режима кадрирования и сбрасываем состояние
                setCropMode(false);
                resetCrop();

                // Сохраняем новое состояние в историю
                // Используем setTimeout, чтобы React успел обработать обновления состояния выше
                setTimeout(saveState, 50);

                message.success(t('imageEditor.messages.cropSuccess'));
                URL.revokeObjectURL(url); // Очищаем память
            };
            img.onerror = () => {
                message.error("Failed to load cropped image.");
                URL.revokeObjectURL(url);
            }
            img.src = url;
        }, 'image/png');
    };

    // Функция для сброса кадрирования
    const resetCrop = () => {
        setCrop({
            unit: '%',
            width: 90,
            height: 90,
            x: 5,
            y: 5
        });
        setCompletedCrop(null);
        setCropAspect(undefined);
        setCropPreset('free');
    };

    // Функция применения пресета кадрирования - ПОЧИНЕННАЯ ВЕРСИЯ
    const applyCropPreset = (presetKey) => {
        const preset = CROP_PRESETS[presetKey];
        setCropPreset(presetKey);
        setCropAspect(preset.aspect);

        if (preset.aspect && imgRef.current) {
            const image = imgRef.current;
            const containerWidth = image.width;
            const containerHeight = image.height;

            let cropWidth, cropHeight;

            // Блядь, теперь правильно вычисляем размер кадрирования
            if (containerWidth / containerHeight > preset.aspect) {
                // Контейнер шире, чем целевое соотношение - используем полную высоту
                cropHeight = containerHeight;
                cropWidth = cropHeight * preset.aspect;
            } else {
                // Контейнер уже, чем целевое соотношение - используем полную ширину
                cropWidth = containerWidth;
                cropHeight = cropWidth / preset.aspect;
            }

            // Центрируем кадрирование
            const x = (containerWidth - cropWidth) / 2;
            const y = (containerHeight - cropHeight) / 2;

            console.log('Crop preset applied:', {
                preset: presetKey,
                aspect: preset.aspect,
                container: { width: containerWidth, height: containerHeight },
                crop: { x, y, width: cropWidth, height: cropHeight }
            });

            setCrop({
                unit: 'px',
                width: cropWidth,
                height: cropHeight,
                x,
                y
            });
        } else if (!preset.aspect) {
            // Свободное кадрирование - используем почти всю область
            setCrop({
                unit: '%',
                width: 90,
                height: 90,
                x: 5,
                y: 5
            });
        }
    };

    // Функция для применения настроек соцсетей
    const applySocialPreset = (presetKey) => {
        const preset = SOCIAL_PRESETS[presetKey];

        // Сначала устанавливаем соотношение сторон для кадрирования
        setCropAspect(preset.width / preset.height);
        setCropPreset('free');

        // Переходим в режим кадрирования
        setCropMode(true);

        // Устанавливаем кадрирование под нужный размер
        if (imgRef.current) {
            const image = imgRef.current;
            const containerWidth = image.width;
            const containerHeight = image.height;
            const targetAspect = preset.width / preset.height;

            let cropWidth, cropHeight;

            if (containerWidth / containerHeight > targetAspect) {
                // Контейнер шире, чем целевое соотношение
                cropHeight = containerHeight;
                cropWidth = cropHeight * targetAspect;
            } else {
                // Контейнер уже, чем целевое соотношение
                cropWidth = containerWidth;
                cropHeight = cropWidth / targetAspect;
            }

            const x = (containerWidth - cropWidth) / 2;
            const y = (containerHeight - cropHeight) / 2;

            setCrop({
                unit: 'px',
                width: cropWidth,
                height: cropHeight,
                x,
                y
            });
        }

        message.success(t('imageEditor.messages.socialPresetApplied', { platform: t(preset.nameKey) }));
        setActiveTab('crop');
    };

    const renderCanvas = () => {
        if (!canvasRef.current || !originalImage) return;

        const canvas = canvasRef.current;
        const ctx = canvas.getContext('2d');

        // Устанавливаем размер canvas равным размеру оригинального изображения
        canvas.width = originalImage.width;
        canvas.height = originalImage.height;

        // Очищаем canvas
        ctx.clearRect(0, 0, canvas.width, canvas.height);

        // Сохраняем состояние контекста
        ctx.save();

        // Применяем трансформации для вращения
        if (rotation !== 0) {
            ctx.translate(canvas.width / 2, canvas.height / 2);
            ctx.rotate((rotation * Math.PI) / 180);
            ctx.translate(-canvas.width / 2, -canvas.height / 2);
        }

        // Рисуем оригинальное изображение на ВЕСЬ canvas
        ctx.drawImage(originalImage, 0, 0, canvas.width, canvas.height);

        // Применяем фильтры
        const filterString = `
            brightness(${100 + brightness}%)
            contrast(${100 + contrast}%)
            saturate(${100 + saturation}%)
            sepia(${sepia}%)
            grayscale(${grayscale}%)
            blur(${blur}px)
            hue-rotate(${hueRotate}deg)
        `;

        // Для применения фильтров создаем временный canvas
        const tempCanvas = document.createElement('canvas');
        tempCanvas.width = canvas.width;
        tempCanvas.height = canvas.height;
        const tempCtx = tempCanvas.getContext('2d');

        tempCtx.filter = filterString;
        tempCtx.drawImage(canvas, 0, 0);

        // Очищаем основной canvas и рисуем отфильтрованное изображение
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.drawImage(tempCanvas, 0, 0);

        // Восстанавливаем состояние контекста
        ctx.restore();

        // Рисуем стикеры
        stickers.forEach(sticker => {
            ctx.save();

            // Применяем прозрачность
            ctx.globalAlpha = (sticker.opacity || 100) / 100;

            // Применяем трансформации для стикера
            if (sticker.rotation) {
                ctx.translate(sticker.x + sticker.width / 2, sticker.y + sticker.height / 2);
                ctx.rotate((sticker.rotation * Math.PI) / 180);
                ctx.translate(-(sticker.x + sticker.width / 2), -(sticker.y + sticker.height / 2));
            }

            // Рисуем стикер
            if (sticker.image) {
                ctx.drawImage(
                    sticker.image,
                    sticker.x,
                    sticker.y,
                    sticker.width,
                    sticker.height
                );
            }

            ctx.restore();
        });

        // Рисуем тексты
        texts.forEach(text => {
            ctx.save();

            // Применяем прозрачность
            ctx.globalAlpha = (text.opacity || 100) / 100;

            // Применяем трансформации для текста
            if (text.rotation) {
                ctx.translate(text.x, text.y + text.fontSize / 2);
                ctx.rotate((text.rotation * Math.PI) / 180);
                ctx.translate(-text.x, -(text.y + text.fontSize / 2));
            }

            // Настраиваем стиль текста
            const fontStyle = `${textBold ? 'bold' : ''} ${textItalic ? 'italic' : ''}`.trim() || 'normal';
            ctx.font = `${fontStyle} ${text.fontSize}px ${text.fontFamily}`;
            ctx.fillStyle = text.fill || '#ffffff';
            ctx.textBaseline = 'top';

            // Применяем текстовые decoration
            if (text.textDecoration === 'underline') {
                ctx.strokeStyle = text.fill || '#ffffff';
                ctx.lineWidth = 1;
            }

            // Рисуем текст
            ctx.fillText(text.text, text.x, text.y);

            // Рисуем подчеркивание если нужно
            if (text.textDecoration === 'underline') {
                const metrics = ctx.measureText(text.text);
                ctx.beginPath();
                ctx.moveTo(text.x, text.y + text.fontSize + 2);
                ctx.lineTo(text.x + metrics.width, text.y + text.fontSize + 2);
                ctx.stroke();
            }

            ctx.restore();
        });

        // Обновляем превью после рендеринга
        updatePreview();
    };

    // Обновляем рендер при изменениях
    useEffect(() => {
        if (originalImage && !cropMode) {
            renderCanvas();
        }
    }, [
        originalImage, brightness, contrast, saturation, sepia, grayscale,
        blur, hueRotate, rotation, texts, stickers, textBold, textItalic, cropMode
    ]);

    // Функция обновления превью
    const updatePreview = () => {
        if (!previewCanvasRef.current || !canvasRef.current || !originalImage) return;

        const sourceCanvas = canvasRef.current;
        const previewCanvas = previewCanvasRef.current;
        const ctx = previewCanvas.getContext('2d');

        // Правильно вычисляем масштаб для превью
        const scale = Math.min(
            canvasSize.width / sourceCanvas.width,
            canvasSize.height / sourceCanvas.height
        ) * 0.9;

        const previewWidth = sourceCanvas.width * scale;
        const previewHeight = sourceCanvas.height * scale;

        previewCanvas.width = canvasSize.width;
        previewCanvas.height = canvasSize.height;

        // Фон для превью
        ctx.fillStyle = '#f0f0f0';
        ctx.fillRect(0, 0, previewCanvas.width, previewCanvas.height);

        const x = (canvasSize.width - previewWidth) / 2;
        const y = (canvasSize.height - previewHeight) / 2;

        // Рисуем изображение на превью
        ctx.drawImage(sourceCanvas, x, y, previewWidth, previewHeight);

        const previewScale = scale;

        // Отображение выделения для текстов
        texts.forEach((text) => {
            if (selectedElement?.id === text.id) {
                ctx.save();
                const fontStyle = `${textBold ? 'bold' : ''} ${textItalic ? 'italic' : ''}`.trim() || 'normal';
                ctx.font = `${fontStyle} ${text.fontSize * previewScale}px ${text.fontFamily}`;
                const metrics = ctx.measureText(text.text);
                const textWidth = metrics.width;
                const textHeight = text.fontSize * previewScale;

                // Рамка выделения
                ctx.strokeStyle = '#1890ff';
                ctx.lineWidth = 2;
                ctx.strokeRect(
                    x + text.x * previewScale - 5,
                    y + text.y * previewScale - 5,
                    textWidth + 10,
                    textHeight + 10
                );

                // Угловые маркеры для resize
                const markerSize = 6;
                ctx.fillStyle = '#1890ff';
                // Левый верхний
                ctx.fillRect(x + text.x * previewScale - markerSize / 2, y + text.y * previewScale - markerSize / 2, markerSize, markerSize);
                // Правый верхний
                ctx.fillRect(x + (text.x + textWidth) * previewScale - markerSize / 2, y + text.y * previewScale - markerSize / 2, markerSize, markerSize);
                // Левый нижний
                ctx.fillRect(x + text.x * previewScale - markerSize / 2, y + (text.y + textHeight) * previewScale - markerSize / 2, markerSize, markerSize);
                // Правый нижний
                ctx.fillRect(x + (text.x + textWidth) * previewScale - markerSize / 2, y + (text.y + textHeight) * previewScale - markerSize / 2, markerSize, markerSize);

                ctx.restore();
            }
        });

        stickers.forEach((sticker) => {
            if (selectedElement?.id === sticker.id) {
                ctx.save();
                ctx.strokeStyle = '#1890ff';
                ctx.lineWidth = 2;

                if (sticker.rotation) {
                    ctx.translate(
                        x + (sticker.x + sticker.width / 2) * previewScale,
                        y + (sticker.y + sticker.height / 2) * previewScale
                    );
                    ctx.rotate((sticker.rotation * Math.PI) / 180);
                    ctx.translate(
                        - (sticker.x + sticker.width / 2) * previewScale,
                        - (sticker.y + sticker.height / 2) * previewScale
                    );
                }

                ctx.strokeRect(
                    x + sticker.x * previewScale,
                    y + sticker.y * previewScale,
                    sticker.width * previewScale,
                    sticker.height * previewScale
                );

                // Угловые маркеры
                const markerSize = 6;
                ctx.fillStyle = '#1890ff';
                ctx.fillRect(x + sticker.x * previewScale - markerSize / 2, y + sticker.y * previewScale - markerSize / 2, markerSize, markerSize);
                ctx.fillRect(x + (sticker.x + sticker.width) * previewScale - markerSize / 2, y + sticker.y * previewScale - markerSize / 2, markerSize, markerSize);
                ctx.fillRect(x + sticker.x * previewScale - markerSize / 2, y + (sticker.y + sticker.height) * previewScale - markerSize / 2, markerSize, markerSize);
                ctx.fillRect(x + (sticker.x + sticker.width) * previewScale - markerSize / 2, y + (sticker.y + sticker.height) * previewScale - markerSize / 2, markerSize, markerSize);

                ctx.restore();
            }
        });
    };

    useEffect(() => {
        if (!visible || !imageUrl) return;

        setImageLoading(true);
        const img = new Image();
        img.crossOrigin = 'anonymous';

        img.onload = () => {
            console.log('Image loaded:', {
                src: imageUrl,
                width: img.width,
                height: img.height,
                naturalWidth: img.naturalWidth,
                naturalHeight: img.naturalHeight
            });

            setOriginalImage(img);
            setImageLoading(false);

            const initialState = {
                texts: [], stickers: [], brightness: 0, contrast: 0, saturation: 0, rotation: 0,
                sepia: 0, grayscale: 0, blur: 0, hueRotate: 0, selectedFilter: 'none'
            };
            setHistory([initialState]);
            setHistoryStep(0);
        };

        img.onerror = () => {
            message.error(t('imageEditor.messages.loadError'));
            setImageLoading(false);
        };

        img.src = imageUrl;
    }, [visible, imageUrl, t]);

    useEffect(() => {
        if (!visible || !containerRef.current) return;

        const updateSize = () => {
            const container = containerRef.current;
            if (container) {
                setCanvasSize({
                    width: container.offsetWidth,
                    height: container.offsetHeight,
                });
            }
        };

        updateSize();
        const resizeObserver = new ResizeObserver(updateSize);
        resizeObserver.observe(containerRef.current);

        return () => resizeObserver.disconnect();
    }, [visible]);

    const getCanvasCoords = (e) => {
        if (!previewCanvasRef.current || !canvasRef.current) return { origX: 0, origY: 0, scale: 1 };
        const canvas = previewCanvasRef.current;
        const rect = canvas.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;

        const sourceCanvas = canvasRef.current;
        const scale = Math.min(
            canvasSize.width / sourceCanvas.width,
            canvasSize.height / sourceCanvas.height
        ) * 0.9;

        const previewWidth = sourceCanvas.width * scale;
        const previewHeight = sourceCanvas.height * scale;
        const offsetX = (canvasSize.width - previewWidth) / 2;
        const offsetY = (canvasSize.height - previewHeight) / 2;

        const origX = (x - offsetX) / scale;
        const origY = (y - offsetY) / scale;

        return { origX, origY, scale };
    };

    const saveState = () => {
        const state = {
            texts: JSON.parse(JSON.stringify(texts)),
            stickers: stickers.map(s => ({ ...s, image: s.image })),
            brightness, contrast, saturation, rotation,
            sepia, grayscale, blur, hueRotate,
            selectedFilter
        };

        const newHistory = history.slice(0, historyStep + 1);
        newHistory.push(state);
        setHistory(newHistory);
        setHistoryStep(newHistory.length - 1);
    };

    const handlePreviewMouseDown = (e) => {
        if (cropMode) return;

        if (e.button === 2) {
            e.preventDefault();
            return;
        }

        const { origX, origY } = getCanvasCoords(e);

        // Проверяем тексты
        for (let i = texts.length - 1; i >= 0; i--) {
            const text = texts[i];
            const ctx = canvasRef.current.getContext('2d');
            const fontStyle = `${textBold ? 'bold' : ''} ${textItalic ? 'italic' : ''}`.trim() || 'normal';
            ctx.font = `${fontStyle} ${text.fontSize}px ${text.fontFamily}`;
            const metrics = ctx.measureText(text.text);

            if (origX >= text.x && origX <= text.x + metrics.width &&
                origY >= text.y && origY <= text.y + text.fontSize) {
                setSelectedElement({ type: 'text', id: text.id, index: i });
                setIsDragging(true);
                setDragOffset({ x: origX - text.x, y: origY - text.y });
                return;
            }
        }

        // Проверяем стикеры
        for (let i = stickers.length - 1; i >= 0; i--) {
            const sticker = stickers[i];
            if (origX >= sticker.x && origX <= sticker.x + sticker.width &&
                origY >= sticker.y && origY <= sticker.y + sticker.height) {
                setSelectedElement({ type: 'sticker', id: sticker.id, index: i });
                setIsDragging(true);
                setDragOffset({ x: origX - sticker.x, y: origY - sticker.y });
                return;
            }
        }

        setSelectedElement(null);
    };

    const handlePreviewMouseMove = (e) => {
        if (cropMode) return;

        if (!isDragging || !selectedElement) return;

        const { origX, origY } = getCanvasCoords(e);

        const newX = origX - dragOffset.x;
        const newY = origY - dragOffset.y;

        if (selectedElement.type === 'text') {
            const newTexts = [...texts];
            newTexts[selectedElement.index] = {
                ...newTexts[selectedElement.index],
                x: newX,
                y: newY
            };
            setTexts(newTexts);
        } else if (selectedElement.type === 'sticker') {
            const newStickers = [...stickers];
            newStickers[selectedElement.index] = {
                ...newStickers[selectedElement.index],
                x: newX,
                y: newY
            };
            setStickers(newStickers);
        }
    };

    const handlePreviewMouseUp = () => {
        if (isDragging) {
            setIsDragging(false);
            saveState();
        }
    };

    // Функции масштабирования
    const scaleElement = (scaleFactor) => {
        if (!selectedElement) return;

        if (selectedElement.type === 'text') {
            const newTexts = [...texts];
            const textIndex = newTexts.findIndex(t => t.id === selectedElement.id);
            if (textIndex !== -1) {
                newTexts[textIndex] = {
                    ...newTexts[textIndex],
                    fontSize: Math.max(12, Math.min(200, newTexts[textIndex].fontSize * scaleFactor))
                };
                setTexts(newTexts);
            }
        } else if (selectedElement.type === 'sticker') {
            const newStickers = [...stickers];
            const stickerIndex = newStickers.findIndex(s => s.id === selectedElement.id);
            if (stickerIndex !== -1) {
                newStickers[stickerIndex] = {
                    ...newStickers[stickerIndex],
                    width: newStickers[stickerIndex].width * scaleFactor,
                    height: newStickers[stickerIndex].height * scaleFactor
                };
                setStickers(newStickers);
            }
        }
        setTimeout(saveState, 50);
    };

    const rotateElement = (angle) => {
        if (!selectedElement) return;

        if (selectedElement.type === 'text') {
            const newTexts = [...texts];
            const textIndex = newTexts.findIndex(t => t.id === selectedElement.id);
            if (textIndex !== -1) {
                newTexts[textIndex] = {
                    ...newTexts[textIndex],
                    rotation: (newTexts[textIndex].rotation || 0) + angle
                };
                setTexts(newTexts);
            }
        } else if (selectedElement.type === 'sticker') {
            const newStickers = [...stickers];
            const stickerIndex = newStickers.findIndex(s => s.id === selectedElement.id);
            if (stickerIndex !== -1) {
                newStickers[stickerIndex] = {
                    ...newStickers[stickerIndex],
                    rotation: (newStickers[stickerIndex].rotation || 0) + angle
                };
                setStickers(newStickers);
            }
        }
        setTimeout(saveState, 50);
    };

    const applyFilter = (filterKey) => {
        const filter = FILTER_PRESETS[filterKey];
        setBrightness(filter.brightness);
        setContrast(filter.contrast);
        setSaturation(filter.saturation);
        setSepia(filter.sepia);
        setGrayscale(filter.grayscale);
        setBlur(filter.blur);
        setHueRotate(filter.hueRotate);
        setSelectedFilter(filterKey);
        setTimeout(saveState, 50);
    };

    const addText = () => {
        if (!textValue.trim()) return message.warning(t('imageEditor.messages.enterText'));

        const newText = {
            id: `text-${Date.now()}`,
            text: textValue,
            x: originalImage.width / 4,
            y: originalImage.height / 4,
            fontSize,
            fill: textColor,
            fontFamily,
            fontStyle: `${textBold ? 'bold' : ''} ${textItalic ? 'italic' : ''}`.trim() || 'normal',
            textDecoration: textUnderline ? 'underline' : '',
            opacity: 100,
            rotation: 0
        };

        setTexts([...texts, newText]);
        setTextValue('');
        setTimeout(saveState, 50);
    };

    const addSticker = (file) => {
        const reader = new FileReader();
        reader.onload = (e) => {
            const img = new Image();
            img.onload = () => {
                const newSticker = {
                    id: `sticker-${Date.now()}`,
                    image: img,
                    x: originalImage.width / 3,
                    y: originalImage.height / 3,
                    width: 150,
                    height: 150,
                    opacity: 100,
                    rotation: 0
                };
                setStickers([...stickers, newSticker]);
                setTimeout(saveState, 50);
            };
            img.src = e.target.result;
        };
        reader.readAsDataURL(file);
    };

    const rotateLeft = () => {
        setRotation(rotation - 90);
        setTimeout(saveState, 50);
    };

    const rotateRight = () => {
        setRotation(rotation + 90);
        setTimeout(saveState, 50);
    };

    const deleteSelected = () => {
        if (!selectedElement) return;

        if (selectedElement.type === 'text') {
            setTexts(texts.filter(t => t.id !== selectedElement.id));
        } else if (selectedElement.type === 'sticker') {
            setStickers(stickers.filter(s => s.id !== selectedElement.id));
        }

        setSelectedElement(null);
        setTimeout(saveState, 50);
    };

    const undo = () => {
        if (historyStep > 0) {
            const newStep = historyStep - 1;
            const state = history[newStep];
            setTexts(state.texts || []);
            setStickers(state.stickers || []);
            setBrightness(state.brightness);
            setContrast(state.contrast);
            setSaturation(state.saturation);
            setRotation(state.rotation);
            setSepia(state.sepia || 0);
            setGrayscale(state.grayscale || 0);
            setBlur(state.blur || 0);
            setHueRotate(state.hueRotate || 0);
            setSelectedFilter(state.selectedFilter || 'none');
            setHistoryStep(newStep);
        }
    };

    const redo = () => {
        if (historyStep < history.length - 1) {
            const newStep = historyStep + 1;
            const state = history[newStep];
            setTexts(state.texts || []);
            setStickers(state.stickers || []);
            setBrightness(state.brightness);
            setContrast(state.contrast);
            setSaturation(state.saturation);
            setRotation(state.rotation);
            setSepia(state.sepia || 0);
            setGrayscale(state.grayscale || 0);
            setBlur(state.blur || 0);
            setHueRotate(state.hueRotate || 0);
            setSelectedFilter(state.selectedFilter || 'none');
            setHistoryStep(newStep);
        }
    };

    const handleSave = async () => {
        try {
            setLoading(true);
            setSelectedElement(null);

            const canvas = canvasRef.current;

            canvas.toBlob(async (blob) => {
                if (!blob) {
                    message.error(t('imageEditor.messages.saveError'));
                    setLoading(false);
                    return;
                }

                const file = new File(
                    [blob],
                    `edited-image-${Date.now()}.png`,
                    { type: 'image/png' }
                );

                await onSave(file);

                message.success(t('imageEditor.messages.saveSuccess'));
                setLoading(false);
            }, 'image/png', 0.95);

        } catch (error) {
            message.error(t('imageEditor.messages.saveError'));
            setLoading(false);
        }
    };

    const resetFilters = () => {
        setBrightness(0);
        setContrast(0);
        setSaturation(0);
        setSepia(0);
        setGrayscale(0);
        setBlur(0);
        setHueRotate(0);
        setSelectedFilter('none');
        setTimeout(saveState, 50);
    };

    return (
        <>
            <Modal
                title={
                    <div className="flex items-center gap-2">
                        <PictureOutlined />
                        <span>{t('imageEditor.title')}</span>
                    </div>
                }
                open={visible}
                onCancel={onCancel}
                width="95%"
                style={{ maxWidth: 1600, top: 20 }}
                footer={
                    <Space wrap>
                        <Button icon={<UndoOutlined />} onClick={undo} disabled={historyStep <= 0}>
                            {t('imageEditor.undo')}
                        </Button>
                        <Button icon={<RedoOutlined />} onClick={redo} disabled={historyStep >= history.length - 1}>
                            {t('imageEditor.redo')}
                        </Button>
                        <Button icon={<DeleteOutlined />} onClick={deleteSelected} danger disabled={!selectedElement}>
                            {t('imageEditor.delete')}
                        </Button>
                        {cropMode ? (
                            <>
                                <Button onClick={() => { setCropMode(false); resetCrop(); }}>
                                    {t('imageEditor.cancelCrop')}
                                </Button>
                                <Button type="primary" onClick={applyCrop}>
                                    {t('imageEditor.applyCrop')}
                                </Button>
                            </>
                        ) : (
                            <>
                                <Button icon={<CloseOutlined />} onClick={onCancel}>
                                    {t('imageEditor.cancel')}
                                </Button>
                                <Button type="primary" icon={<CheckOutlined />} onClick={handleSave} loading={loading} disabled={imageLoading}>
                                    {t('imageEditor.save')}
                                </Button>
                            </>
                        )}
                    </Space>
                }
            >
                <div className="flex flex-col lg:flex-row gap-4">
                    <div className="flex-1 min-w-0">
                        <div
                            ref={containerRef}
                            className="relative w-full bg-gray-900 border-2 border-gray-700 rounded-lg overflow-hidden"
                            style={{ height: '70vh', minHeight: '500px' }}
                        >
                            {imageLoading && (
                                <div className="absolute inset-0 flex items-center justify-center z-10 bg-black/50">
                                    <Spin size="large" tip={t('imageEditor.loading')} />
                                </div>
                            )}

                            <canvas
                                ref={canvasRef}
                                style={{ display: 'none' }}
                            />

                            {cropMode && originalImage ? (
                                <div className="w-full h-full flex items-center justify-center p-4">
                                    <ReactCrop
                                        crop={crop}
                                        onChange={(_, percentCrop) => setCrop(percentCrop)}
                                        onComplete={(c) => setCompletedCrop(c)}
                                        aspect={cropAspect}
                                        className="max-w-full max-h-full"
                                        ruleOfThirds
                                    >
                                        <img
                                            ref={imgRef}
                                            src={originalImage.src}
                                            style={{
                                                maxWidth: '100%',
                                                maxHeight: '100%',
                                                filter: `
                                                    brightness(${100 + brightness}%)
                                                    contrast(${100 + contrast}%)
                                                    saturate(${100 + saturation}%)
                                                    sepia(${sepia}%)
                                                    grayscale(${grayscale}%)
                                                    blur(${blur}px)
                                                    hue-rotate(${hueRotate}deg)
                                                `
                                            }}
                                            onLoad={() => {
                                                // Автоматически устанавливаем область кадрирования при загрузке
                                                if (imgRef.current && !completedCrop) {
                                                    const { width, height } = imgRef.current;
                                                    // Блядь, теперь используем почти всю область по умолчанию
                                                    setCrop({
                                                        unit: 'px',
                                                        width: width * 0.9,
                                                        height: height * 0.9,
                                                        x: width * 0.05,
                                                        y: height * 0.05
                                                    });
                                                }
                                            }}
                                        />
                                    </ReactCrop>
                                </div>
                            ) : (
                                <canvas
                                    ref={previewCanvasRef}
                                    width={canvasSize.width}
                                    height={canvasSize.height}
                                    onMouseDown={handlePreviewMouseDown}
                                    onMouseMove={handlePreviewMouseMove}
                                    onMouseUp={handlePreviewMouseUp}
                                    onMouseLeave={handlePreviewMouseUp}
                                    style={{
                                        cursor: isDragging ? 'grabbing' : 'default'
                                    }}
                                    className="w-full h-full"
                                />
                            )}
                        </div>

                        <div className="mt-3 bg-gray-100 p-2 rounded-lg flex flex-wrap items-center justify-center gap-2">
                            <Button
                                icon={<RotateLeftOutlined />}
                                onClick={rotateLeft}
                                title={t('imageEditor.rotateLeft')}
                            />
                            <Button
                                icon={<RotateRightOutlined />}
                                onClick={rotateRight}
                                title={t('imageEditor.rotateRight')}
                            />
                            <Button
                                icon={<ScissorOutlined />}
                                type={cropMode ? "primary" : "default"}
                                onClick={() => {
                                    setCropMode(!cropMode);
                                    if (!cropMode) {
                                        resetCrop();
                                    }
                                }}
                                title={t('imageEditor.crop')}
                            />
                            <Button
                                icon={<FilterOutlined />}
                                onClick={() => setActiveTab('presets')}
                                type={activeTab === 'presets' ? "primary" : "default"}
                                title={t('imageEditor.filters')}
                            />
                            <Button
                                icon={<BgColorsOutlined />}
                                onClick={() => setActiveTab('adjust')}
                                type={activeTab === 'adjust' ? "primary" : "default"}
                                title={t('imageEditor.adjust')}
                            />
                            <Button
                                icon={<FontSizeOutlined />}
                                onClick={() => setActiveTab('text')}
                                type={activeTab === 'text' ? "primary" : "default"}
                                title={t('imageEditor.text')}
                            />
                            <Button
                                icon={<PictureOutlined />}
                                onClick={() => setActiveTab('stickers')}
                                type={activeTab === 'stickers' ? "primary" : "default"}
                                title={t('imageEditor.stickers')}
                            />
                        </div>
                    </div>

                    <div className="w-full lg:w-96 flex-shrink-0">
                        <Tabs
                            activeKey={activeTab}
                            onChange={setActiveTab}
                            type="card"
                            className="editor-tabs"
                            items={[
                                {
                                    key: 'social',
                                    label: <span><InstagramOutlined /> {t('imageEditor.social.title')}</span>,
                                    children: (
                                        <div className="max-h-[60vh] overflow-y-auto pr-2">
                                            <div className="p-4 bg-blue-50 rounded-lg mb-4">
                                                <h4 className="font-bold mb-2">{t('imageEditor.social.instructionTitle')}</h4>
                                                <p className="text-sm text-blue-800">
                                                    {t('imageEditor.social.instructionDescription')}
                                                </p>
                                            </div>

                                            <Row gutter={[12, 12]}>
                                                {Object.entries(SOCIAL_PRESETS).map(([key, preset]) => (
                                                    <Col span={12} key={key}>
                                                        <Card
                                                            hoverable
                                                            className="text-center cursor-pointer transition-all hover:shadow-lg"
                                                            bodyStyle={{ padding: '12px' }}
                                                            onClick={() => applySocialPreset(key)}
                                                        >
                                                            <div className="text-2xl mb-2 text-blue-600">
                                                                {preset.icon}
                                                            </div>
                                                            <div className="font-semibold text-sm mb-1">
                                                                {t(preset.nameKey)}
                                                            </div>
                                                            <div className="text-xs text-gray-500 mb-2">
                                                                {preset.width} × {preset.height}
                                                            </div>
                                                            <div className="text-xs text-gray-600">
                                                                {t(preset.descriptionKey)}
                                                            </div>
                                                        </Card>
                                                    </Col>
                                                ))}
                                            </Row>

                                            <Divider />

                                            <div className="p-3 bg-green-50 rounded-lg">
                                                <h5 className="font-bold mb-2">{t('imageEditor.social.tipsTitle')}</h5>
                                                <ul className="text-xs text-green-800 space-y-1">
                                                    <li>• {t('imageEditor.social.tip1')}</li>
                                                    <li>• {t('imageEditor.social.tip2')}</li>
                                                    <li>• {t('imageEditor.social.tip3')}</li>
                                                </ul>
                                            </div>
                                        </div>
                                    ),
                                },
                                {
                                    key: 'crop',
                                    label: <span><ScissorOutlined /> {t('imageEditor.crop.title')}</span>,
                                    children: (
                                        <div className="max-h-[60vh] overflow-y-auto pr-2 space-y-4">
                                            <div className="p-4 bg-blue-50 rounded-lg border border-blue-200 mb-4">
                                                <h4 className="font-bold mb-2">{t('imageEditor.crop.instructionTitle')}</h4>
                                                <p className="text-sm text-blue-800">
                                                    {t('imageEditor.crop.instructionDescription')}
                                                </p>
                                            </div>

                                            <div className="bg-gray-50 p-3 rounded-lg mb-4">
                                                <div className="flex justify-between items-center mb-2">
                                                    <span className="font-medium">{t('imageEditor.crop.originalSize')}</span>
                                                    <span className="text-sm text-gray-600">
                                                        {originalImage?.width} × {originalImage?.height}
                                                    </span>
                                                </div>
                                                {completedCrop && (
                                                    <div className="flex justify-between items-center">
                                                        <span className="font-medium">{t('imageEditor.crop.cropSize')}</span>
                                                        <span className="text-sm text-blue-600 font-bold">
                                                            {Math.round(completedCrop.width)} × {Math.round(completedCrop.height)}
                                                        </span>
                                                    </div>
                                                )}
                                            </div>

                                            <div>
                                                <label className="block mb-3 font-medium">
                                                    {t('imageEditor.crop.presets')}
                                                </label>
                                                <Row gutter={[8, 8]}>
                                                    {Object.entries(CROP_PRESETS).map(([key, preset]) => (
                                                        <Col span={8} key={key}>
                                                            <Card
                                                                hoverable
                                                                className={`text-center cursor-pointer transition-all ${cropPreset === key ? 'ring-2 ring-blue-500 shadow-lg' : ''}`}
                                                                bodyStyle={{ padding: '8px' }}
                                                                onClick={() => applyCropPreset(key)}
                                                            >
                                                                <div className="text-lg mb-1">{t(preset.nameKey)}</div>
                                                                {preset.aspect && (
                                                                    <div className="text-xs text-gray-500">
                                                                        {preset.aspect}
                                                                    </div>
                                                                )}
                                                            </Card>
                                                        </Col>
                                                    ))}
                                                </Row>
                                            </div>

                                            <div className="pt-4">
                                                <Button
                                                    type={cropMode ? 'primary' : 'default'}
                                                    icon={<ScissorOutlined />}
                                                    onClick={() => {
                                                        setCropMode(!cropMode);
                                                        if (!cropMode) {
                                                            resetCrop();
                                                        }
                                                    }}
                                                    block
                                                    size="large"
                                                >
                                                    {t(cropMode ? 'imageEditor.crop.exit' : 'imageEditor.crop.enter')}
                                                </Button>
                                            </div>

                                            {cropMode && (
                                                <div className="p-4 bg-green-50 rounded-lg border border-green-200">
                                                    <p className="text-sm font-medium mb-2 text-green-800">
                                                        {t('imageEditor.crop.active')}
                                                    </p>
                                                    <p className="text-sm text-green-600 mb-3">
                                                        {t('imageEditor.crop.instructions')}
                                                    </p>
                                                    <div className="space-y-2">
                                                        <Button
                                                            type="primary"
                                                            onClick={applyCrop}
                                                            block
                                                            disabled={!completedCrop}
                                                        >
                                                            {t('imageEditor.crop.apply')}
                                                        </Button>
                                                        <Button
                                                            onClick={resetCrop}
                                                            block
                                                        >
                                                            {t('imageEditor.crop.reset')}
                                                        </Button>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    ),
                                },
                                {
                                    key: 'presets',
                                    label: <span><FilterOutlined /> {t('imageEditor.filters.title')}</span>,
                                    children: (
                                        <div className="max-h-[60vh] overflow-y-auto pr-2">
                                            <Row gutter={[8, 8]}>
                                                {Object.entries(FILTER_PRESETS).map(([key, filter]) => (
                                                    <Col span={8} key={key}>
                                                        <Card
                                                            hoverable
                                                            className={`text-center cursor-pointer transition-all ${selectedFilter === key ? 'ring-2 ring-blue-500 shadow-lg' : ''}`}
                                                            bodyStyle={{ padding: '8px' }}
                                                            onClick={() => applyFilter(key)}
                                                        >
                                                            <div className="h-16 bg-gradient-to-br from-gray-400 to-gray-600 rounded mb-2 flex items-center justify-center text-white font-bold">
                                                                {t(filter.nameKey).slice(0, 2).toUpperCase()}
                                                            </div>
                                                            <div className="text-xs">{t(filter.nameKey)}</div>
                                                        </Card>
                                                    </Col>
                                                ))}
                                            </Row>
                                        </div>
                                    ),
                                },
                                {
                                    key: 'adjust',
                                    label: <span><BgColorsOutlined /> {t('imageEditor.adjust.title')}</span>,
                                    children: (
                                        <div className="max-h-[60vh] overflow-y-auto pr-2">
                                            <div className="space-y-4">
                                                <div>
                                                    <label className="font-medium mb-2 flex justify-between">
                                                        <span>{t('imageEditor.adjust.brightness')}</span>
                                                        <span className="text-gray-500">{brightness}</span>
                                                    </label>
                                                    <Slider min={-100} max={100} value={brightness} onChange={setBrightness} onAfterChange={saveState} />
                                                </div>
                                                <div>
                                                    <label className="font-medium mb-2 flex justify-between">
                                                        <span>{t('imageEditor.adjust.contrast')}</span>
                                                        <span className="text-gray-500">{contrast}</span>
                                                    </label>
                                                    <Slider min={-100} max={100} value={contrast} onChange={setContrast} onAfterChange={saveState} />
                                                </div>
                                                <div>
                                                    <label className="font-medium mb-2 flex justify-between">
                                                        <span>{t('imageEditor.adjust.saturation')}</span>
                                                        <span className="text-gray-500">{saturation}</span>
                                                    </label>
                                                    <Slider min={-100} max={100} value={saturation} onChange={setSaturation} onAfterChange={saveState} />
                                                </div>
                                                <div>
                                                    <label className="font-medium mb-2 flex justify-between">
                                                        <span>{t('imageEditor.adjust.sepia')}</span>
                                                        <span className="text-gray-500">{sepia}</span>
                                                    </label>
                                                    <Slider min={0} max={100} value={sepia} onChange={setSepia} onAfterChange={saveState} />
                                                </div>
                                                <div>
                                                    <label className="font-medium mb-2 flex justify-between">
                                                        <span>{t('imageEditor.adjust.grayscale')}</span>
                                                        <span className="text-gray-500">{grayscale}</span>
                                                    </label>
                                                    <Slider min={0} max={100} value={grayscale} onChange={setGrayscale} onAfterChange={saveState} />
                                                </div>
                                                <div>
                                                    <label className="font-medium mb-2 flex justify-between">
                                                        <span>{t('imageEditor.adjust.blur')}</span>
                                                        <span className="text-gray-500">{blur}</span>
                                                    </label>
                                                    <Slider min={0} max={10} step={0.5} value={blur} onChange={setBlur} onAfterChange={saveState} />
                                                </div>
                                                <div>
                                                    <label className="font-medium mb-2 flex justify-between">
                                                        <span>{t('imageEditor.adjust.hue')}</span>
                                                        <span className="text-gray-500">{hueRotate}°</span>
                                                    </label>
                                                    <Slider min={0} max={360} value={hueRotate} onChange={setHueRotate} onAfterChange={saveState} />
                                                </div>
                                                <div className="pt-4">
                                                    <Button onClick={resetFilters} block danger>
                                                        {t('imageEditor.adjust.reset')}
                                                    </Button>
                                                </div>
                                            </div>
                                        </div>
                                    ),
                                },
                                {
                                    key: 'text',
                                    label: <span><FontSizeOutlined /> {t('imageEditor.text.title')}</span>,
                                    children: (
                                        <div className="max-h-[60vh] overflow-y-auto pr-2 space-y-4">
                                            <div className="p-3 bg-blue-50 rounded-lg mb-2">
                                                <h4 className="font-bold mb-1">{t('imageEditor.text.addTitle')}</h4>
                                                <p className="text-xs text-blue-800">
                                                    {t('imageEditor.text.addDescription')}
                                                </p>
                                            </div>

                                            <div>
                                                <label className="block mb-2 font-medium">{t('imageEditor.text.content')}</label>
                                                <Input.TextArea
                                                    value={textValue}
                                                    onChange={(e) => setTextValue(e.target.value)}
                                                    placeholder={t('imageEditor.text.placeholder')}
                                                    rows={3}
                                                    maxLength={100}
                                                    showCount
                                                />
                                            </div>

                                            <div className="grid grid-cols-2 gap-3">
                                                <div>
                                                    <label className="block mb-2 font-medium">{t('imageEditor.text.font')}</label>
                                                    <Select
                                                        value={fontFamily}
                                                        onChange={setFontFamily}
                                                        style={{ width: '100%' }}
                                                        options={[
                                                            'Arial', 'Times New Roman', 'Courier New', 'Georgia',
                                                            'Verdana', 'Impact', 'Comic Sans MS', 'Trebuchet MS'
                                                        ].map(f => ({ value: f, label: f }))}
                                                    />
                                                </div>
                                                <div>
                                                    <label className="block mb-2 font-medium">{t('imageEditor.text.size')}</label>
                                                    <Slider min={12} max={200} value={fontSize} onChange={setFontSize} />
                                                </div>
                                            </div>

                                            <div>
                                                <label className="block mb-2 font-medium">{t('imageEditor.text.color')}</label>
                                                <ColorPicker
                                                    value={textColor}
                                                    onChange={(c) => setTextColor(c.toHexString())}
                                                    showText
                                                    style={{ width: '100%' }}
                                                />
                                            </div>

                                            <div>
                                                <label className="block mb-2 font-medium">{t('imageEditor.text.style')}</label>
                                                <Space wrap className="w-full justify-center">
                                                    <Button type={textBold ? 'primary' : 'default'} icon={<BoldOutlined />} onClick={() => setTextBold(!textBold)}>
                                                        {t('imageEditor.text.bold')}
                                                    </Button>
                                                    <Button type={textItalic ? 'primary' : 'default'} icon={<ItalicOutlined />} onClick={() => setTextItalic(!textItalic)}>
                                                        {t('imageEditor.text.italic')}
                                                    </Button>
                                                    <Button type={textUnderline ? 'primary' : 'default'} icon={<UnderlineOutlined />} onClick={() => setTextUnderline(!textUnderline)}>
                                                        {t('imageEditor.text.underline')}
                                                    </Button>
                                                </Space>
                                            </div>

                                            <Button type="primary" block onClick={addText} size="large" disabled={!textValue.trim()}>
                                                {t('imageEditor.text.add')}
                                            </Button>

                                            {texts.length > 0 && (
                                                <div className="p-4 bg-gray-50 rounded-lg border border-gray-200 mt-4">
                                                    <p className="text-sm font-medium mb-2">{t('imageEditor.text.count', { count: texts.length })}</p>
                                                    <p className="text-xs text-gray-600">
                                                        <Trans i18nKey="imageEditor.text.instructions">
                                                            • Кликните на текст для выбора<br />
                                                            • Перетаскивайте для перемещения<br />
                                                            • Выберите текст и нажмите "Удалить" для удаления
                                                        </Trans>
                                                    </p>
                                                </div>
                                            )}
                                        </div>
                                    ),
                                },
                                {
                                    key: 'stickers',
                                    label: <span><PictureOutlined /> {t('imageEditor.stickers.title')}</span>,
                                    children: (
                                        <div className="space-y-4">
                                            <div className="p-4 bg-blue-50 rounded-lg border border-blue-200 mb-2">
                                                <h4 className="font-bold mb-1">{t('imageEditor.stickers.addTitle')}</h4>
                                                <p className="text-xs text-blue-800">
                                                    {t('imageEditor.stickers.addDescription')}
                                                </p>
                                            </div>

                                            <Upload
                                                accept="image/*"
                                                showUploadList={false}
                                                beforeUpload={(file) => {
                                                    addSticker(file);
                                                    return false;
                                                }}
                                            >
                                                <Button type="primary" icon={<PictureOutlined />} block size="large">
                                                    {t('imageEditor.stickers.upload')}
                                                </Button>
                                            </Upload>

                                            {stickers.length > 0 && (
                                                <div className="p-4 bg-gray-50 rounded-lg border border-gray-200 mt-4">
                                                    <p className="text-sm font-medium mb-2">{t('imageEditor.stickers.count', { count: stickers.length })}</p>
                                                    <p className="text-xs text-gray-600">
                                                        <Trans i18nKey="imageEditor.stickers.instructions">
                                                            • Кликните на стикер для выбора<br />
                                                            • Перетаскивайте для перемещения<br />
                                                            • Выберите стикер и нажмите "Удалить" для удаления
                                                        </Trans>
                                                    </p>
                                                </div>
                                            )}
                                        </div>
                                    ),
                                },
                            ]}
                        />
                    </div>
                </div>
            </Modal>

            <style jsx>{`
                .editor-tabs .ant-tabs-content-holder {
                    max-height: 60vh;
                    overflow-y: auto;
                }
            `}</style>
        </>
    );
};

export default ImageEditorModal;